(function () {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  /**
   * HelloWorld
   * ======================================
   * - example js module
   */
  var MESSAGE = "Hello World! From HelloWorld.js";
  var HelloWorld = /*#__PURE__*/_createClass(function HelloWorld() {
    _classCallCheck(this, HelloWorld);

    _defineProperty(this, "loadHandler", function () {
      console.log(MESSAGE);
    });

    window.addEventListener("load", this.loadHandler, false);
  });
  new HelloWorld();

})();

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NyaXB0cy5qcyIsInNvdXJjZXMiOlsid2ViL2FwcC90aGVtZXMvaXByZXNzL3NyYy9zY3JpcHRzL21vZHVsZXMvSGVsbG9Xb3JsZC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEhlbGxvV29ybGRcbiAqID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4gKiAtIGV4YW1wbGUganMgbW9kdWxlXG4gKi9cblxuY29uc3QgTUVTU0FHRSA9IFwiSGVsbG8gV29ybGQhIEZyb20gSGVsbG9Xb3JsZC5qc1wiO1xuXG5leHBvcnQgY2xhc3MgSGVsbG9Xb3JsZCB7XG4gIGNvbnN0cnVjdG9yKCkge1xuICAgIHdpbmRvdy5hZGRFdmVudExpc3RlbmVyKFwibG9hZFwiLCB0aGlzLmxvYWRIYW5kbGVyLCBmYWxzZSk7XG4gIH1cblxuICBsb2FkSGFuZGxlciA9ICgpID0+IHtcbiAgICBjb25zb2xlLmxvZyhNRVNTQUdFKTtcbiAgfTtcbn1cblxubmV3IEhlbGxvV29ybGQoKTtcbiJdLCJuYW1lcyI6WyJNRVNTQUdFIiwiSGVsbG9Xb3JsZCIsImNvbnNvbGUiLCJsb2ciLCJ3aW5kb3ciLCJhZGRFdmVudExpc3RlbmVyIiwibG9hZEhhbmRsZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7RUFBQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBRUEsSUFBTUEsT0FBTyxHQUFHLGlDQUFoQixDQUFBO0VBRWFDLElBQUFBLFVBQWIsNkJBQ0UsU0FBYyxVQUFBLEdBQUE7RUFBQSxFQUFBLGVBQUEsQ0FBQSxJQUFBLEVBQUEsVUFBQSxDQUFBLENBQUE7O0VBQUEsRUFBQSxlQUFBLENBQUEsSUFBQSxFQUFBLGFBQUEsRUFJQSxZQUFNO01BQ2xCQyxPQUFPLENBQUNDLEdBQVIsQ0FBWUgsT0FBWixDQUFBLENBQUE7S0FMWSxDQUFBLENBQUE7O0lBQ1pJLE1BQU0sQ0FBQ0MsZ0JBQVAsQ0FBd0IsTUFBeEIsRUFBZ0MsSUFBS0MsQ0FBQUEsV0FBckMsRUFBa0QsS0FBbEQsQ0FBQSxDQUFBO0VBQ0QsQ0FISCxDQUFBLENBQUE7RUFVQSxJQUFJTCxVQUFKLEVBQUE7Ozs7OzsifQ==
